<p-card class="crew-card">

  <div class="p-grid">
    <div class="p-col">
      <p-datepicker [(ngModel)]="bigDayBucketSubrange.fromDate" class="secondary" [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}" [maxDate]="bigDayBucketSubrange.toDate" [minDate]="bigDayBucket.fromDate"
        appendTo="body">
      </p-datepicker>
    </div>
    <div class="p-col-1 to">
      to
    </div>
    <div class="p-col">
      <p-datepicker [(ngModel)]="bigDayBucketSubrange.toDate" class="secondary" [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}" [minDate]="bigDayBucketSubrange.fromDate" [maxDate]="bigDayBucket.toDate"
        appendTo="body">
      </p-datepicker>
    </div>
  </div>

  <div class="toggle-crew-information">
    <div class="crew-information">
      @if (bigDayEquipment) {
        <div [id]="'subrangeEquipmentList-' + bigDayBucketSubrange.id"
          [cdkDropListData]="bigDayEquipment" [cdkDropListConnectedTo]="multidayDragAndDropService.allCDKEquipmentListIds"
          cdkDropList (cdkDropListDropped)="drop($event)">
          <div style="padding: 6px 0;">
            <span>Equipment</span>
          </div>
          @for (bigDayEqp of bigDayEquipment; track bigDayEqp) {
            <div class="inner-card">
              <app-equipment-card [equipment]="bigDayEqp.equipment" [deleteable]="true"
              (deleted)="deleteEquipmentFromBigDayBucketSubrange($event)"></app-equipment-card>
            </div>
          }
          @if (bigDayEquipment.length == 0) {
            <div class="inner-card drag-placeholder">
              <p-card>Drag Equipment Here</p-card>
            </div>
          }
        </div>
      }
      @if (bigDayEmployees) {
        <div [id]="'subrangeEmployeeList-' + bigDayBucketSubrange.id"
          [cdkDropListData]="bigDayEmployees" [cdkDropListConnectedTo]="multidayDragAndDropService.allCDKEmployeeListIds"
          cdkDropList (cdkDropListDropped)="drop($event)">
          <div style="padding: 6px 0;">
            <span>Employees</span>
          </div>
          @for (bigDayEmployee of bigDayEmployees; track bigDayEmployee) {
            <div class="inner-card">
              <app-employee-card [employee]="bigDayEmployee.employee" [deleteable]="true"
              (deleted)="deleteEmployeeFromBigDayBucketSubrange($event)"></app-employee-card>
            </div>
          }
          @if (bigDayEmployees && bigDayEmployees.length == 0) {
            <div class="inner-card drag-placeholder">
              <p-card>Drag Employee Here</p-card>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <p-footer class="clearfix">
    <p-button type="button" icon="pi pi-trash"
      class="deleteButton btn-sm float-right" severity="danger"
    (click)="onDelete()"></p-button>
  </p-footer>
</p-card>